import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! Our team will get back to you soon.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) { toast.error(apiErr(err)); } finally { setSending(false); }
  };
  return (
    <div className="col-span-2">
      <h4 className="text-white font-semibold text-sm mb-3 flex items-center gap-2"><Mail size={15} />Contact Us</h4>
      <form onSubmit={submit} className="space-y-2.5" data-testid="contact-form">
        <div className="grid grid-cols-2 gap-2.5">
          <Input required placeholder="Your name" value={form.name} onChange={set("name")} className="bg-white/5 border-white/15 text-white placeholder:text-zinc-500 h-9 text-sm" data-testid="contact-name" />
          <Input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="bg-white/5 border-white/15 text-white placeholder:text-zinc-500 h-9 text-sm" data-testid="contact-email" />
        </div>
        <Input placeholder="Subject" value={form.subject} onChange={set("subject")} className="bg-white/5 border-white/15 text-white placeholder:text-zinc-500 h-9 text-sm" data-testid="contact-subject" />
        <Textarea required placeholder="How can we help you?" value={form.message} onChange={set("message")} rows={3} className="bg-white/5 border-white/15 text-white placeholder:text-zinc-500 text-sm resize-none" data-testid="contact-message" />
        <Button type="submit" disabled={sending} className="rounded-full bg-[#FF6A1A] hover:bg-[#e85c10] h-9 px-6" data-testid="contact-submit">{sending ? "Sending…" : "Send message"}</Button>
      </form>
    </div>
  );
}

export function StoreFooter() {
  const cols = [
    ["Get to Know Us", ["About Qava", "Careers", "Press", "Qava Blog"]],
    ["Let Us Help You", ["Your Account", "Track Order", "Shipping & Delivery", "Returns & Refunds", "Help Center"]],
  ];
  return (
    <footer className="mt-10 bg-[#101A3D] text-zinc-300">
      <Link to="/" className="block bg-[#17224A] text-center py-3 text-sm text-white hover:bg-[#1e2c5c]">Back to top ↑</Link>
      <div className="max-w-[1500px] mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        {cols.map(([h, items]) => (
          <div key={h}>
            <h4 className="text-white font-semibold text-sm mb-3">{h}</h4>
            <ul className="space-y-2 text-xs">
              {items.map((i) => <li key={i}><Link to="/track" className="hover:text-white">{i}</Link></li>)}
            </ul>
          </div>
        ))}
        <ContactForm />
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="font-display text-xl font-extrabold text-white">Qava<span className="text-[#FF6A1A]">.</span></div>
          <p className="text-xs text-zinc-500">© 2026 Qava Marketplace · Powered by a multi-supplier dropship engine</p>
        </div>
      </div>
    </footer>
  );
}
